import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import { useRouter } from 'next/router';

import { getFullArtistName, isBrowser } from '@utils/helpers';
import { Artist } from '@definitions/artworks.types';

import { Container, SocialShareTitle, SocialShareFoldout, SocialShareFoldoutItem } from './socialShare.styles';

export interface SocialShareProps {
  title: string;
  artist: Artist;
}

export const SocialShare = ({ title, artist }: SocialShareProps) => {
  const router = useRouter();
  const intl = useIntl();
  const origin = isBrowser() ? location?.origin : '';
  const defaultTitle = intl.formatMessage({
    id: 'socialShare.defaultTitle',
    defaultMessage: 'PLATFORM',
  });
  const sharedUrl = `${origin}${router.asPath}`;
  const fullArtistName = getFullArtistName(artist);
  const sharedTitle = `${title} ${fullArtistName} | ${defaultTitle}`;
  const emailSubject = intl.formatMessage({
    id: 'socialShare.emailSubject',
    defaultMessage: 'An artwork you might like',
  });
  const emailBody = intl.formatMessage({
    id: 'socialShare.emailBody',
    defaultMessage: 'I saw this on Platform and thought you would love it:',
  });

  return (
    <Container tabIndex={0}>
      <SocialShareTitle>
        <span>
          <FormattedMessage id="socialShare.Title" defaultMessage="Share" />
        </span>
      </SocialShareTitle>

      <SocialShareFoldout>
        <SocialShareFoldoutItem>
          <TwitterShareButton title={sharedTitle} url={sharedUrl}>
            <FormattedMessage id="socialShare.linkLabelTwitter" defaultMessage="Twitter" />
          </TwitterShareButton>
        </SocialShareFoldoutItem>
        <SocialShareFoldoutItem>
          <FacebookShareButton quote={sharedTitle} url={sharedUrl}>
            <FormattedMessage id="socialShare.linkLabelFacebook" defaultMessage="Facebook" />
          </FacebookShareButton>
        </SocialShareFoldoutItem>
        <SocialShareFoldoutItem>
          <EmailShareButton url={sharedUrl} subject={emailSubject} body={emailBody} separator={'\n'}>
            <FormattedMessage id="socialShare.linkLabelEmail" defaultMessage="Email" />
          </EmailShareButton>
        </SocialShareFoldoutItem>
      </SocialShareFoldout>
    </Container>
  );
};
